module.exports = function(h, row, name) {
    let length = row.outlets.length;

    if (length < 1) {
        return <i>No {code} assigned</i>;
    }

    if (length === 1) {
        return row.outlets[0].code;
    }

    return (
        <i>
            Assigned to {row.outlets.length} {code}
        </i>
    );
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/pricebook/site_id.jsx